import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ArtistPortfolioProductsService, PortfolioProductViewModel, ShareableProductLink } from 'src/app/Services/artist-portfolio-products/artist-portfolio-products.service';
import { ImageUtils } from 'src/app/shared/utils/image-utils';

@Component({
    selector: 'app-show-portfolios-products-dialog',
    templateUrl: './show-portfolios-products-dialog.component.html',
    styleUrls: ['./show-portfolios-products-dialog.component.css'],
    standalone: false
})
export class ShowPortfoliosProductsDialogComponent implements OnInit {
    @Input() PortfolioId!: string;
    @Input() display: boolean = false;
    @Output() onClose = new EventEmitter<void>();
    public products: ShareableProductLink | null = null;
    public loading: boolean = true;

    constructor(private ArtistPortfolioProductsService: ArtistPortfolioProductsService,
        private router: Router

    ) { }

    ngOnInit(): void {
        if (this.PortfolioId) {
            this.fetchPortfolioProducts(this.PortfolioId);
        }
    }

    public fetchPortfolioProducts(linkId: string) {
        this.loading = true;
        this.ArtistPortfolioProductsService.getArtistProtfolioProduct(linkId).subscribe({
            next: (res) => {
                res.PortfolioProductsViewModel?.forEach((product: any) => {
                    product.ArtistProduct.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(
                        product.ArtistProduct.ProductImgUrl || 'assets/images/No-Image.png'
                    );
                });

                this.products = res;
                this.loading = false;
            },
            error: (err) => {
                console.error('Error fetching portfolio products:', err);
                this.loading = false;
            }
        });
    }

    public closeDialog() {
        this.onClose.emit();
    }

    public naviGateToViewPage(product: PortfolioProductViewModel) {
        this.router.navigate(['/', product.ArtistProduct.ArtistId, 'artworks', product.ArtistProduct.Id]);
    }
}
